<template>
  <div class="modal" :class="{ 'is-active': showModal }" ref="modal">
    <div class="modal-background" @click="handleCancel"></div>
    <div class="modal-content">
      <button class="modal-close" aria-label="close" @click="handleCancel">
        <span>&times;</span>
      </button>
      <div class="box">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'Modal',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
  },
  mounted() {
    gsap.set(this.$el, { autoAlpha: 0, scale: 0.8 });
  },
  watch: {
    showModal(newVal) {
      if (newVal) {   
        gsap.to(this.$el, { duration: 0, autoAlpha: 1, scale: 1 });
      } else {
        gsap.to(this.$el, { duration: 0, autoAlpha: 0, scale: 0.8 });
      }
    },
  },
};
</script>

<style scoped>
/* Add custom styles for the modal */
.modal {
  display: none;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.modal.is-active {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-background {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  max-width: 600px;
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 1.5rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #000;
}

.modal-close span {
  display: inline-block;
  width: 100%;
  height: 100%;
}
</style>
